// src/redux/sagas/appInitializationSaga.ts
import { fork, put } from 'redux-saga/effects';
import { SiteContent } from '../../types/siteContent';
import { fetchTpnConfigRequest } from '../slices/tpnConfigSlice';
import { fetchMenuItemsRequest } from '../slices/menuItemsSlice';
import { fetchModifiersRequest } from '../slices/modifiersSlice';
import { fetchSubscriptionRequest } from '../slices/subscriptionSlice';
import { preloadRequiredWidgets } from '../../utils/widgetPreloader';

/**
 * Initializes all background tasks after site content is loaded
 * This includes: TPN config, table availability, menu items, modifiers, and widget preloading
 */
export function* initializeAppBackgroundTasks(siteContentData: SiteContent): Generator<any, void, any> {
  try {

     // 1. Preload essential widgets for better performance
    const widgets = siteContentData?.widgets || [];
    const pages = siteContentData?.pages || {};
    yield fork(preloadRequiredWidgets, widgets, pages);

   // Fetch subscription status after site content
    yield put(fetchSubscriptionRequest());

    // 2. Load TPN configuration for payment processing
    yield put(fetchTpnConfigRequest());
    
    // 3. Load menu items and modifiers (needed for popular widgets on HomePage)
    yield put(fetchMenuItemsRequest());
    yield put(fetchModifiersRequest());
    
  } catch (error) {
    // Silently handle background task errors to avoid blocking the main app
    console.warn('Background initialization task failed:', error);
  }
}
